/**
 * Item Registry
 *
 * Maps TimelineItem.type to functional item components.
 * Used by TimelineEventList to render appropriate component for each item.
 */

import type { ComponentType } from 'react';

import { ITEM_TYPES } from '../collapseAssociationEvents';
import { AssociationAddedItem } from './AssociationAddedItem';
import { AssociationChangedItem } from './AssociationChangedItem';
import { AssociationRemovedItem } from './AssociationRemovedItem';
import { ObjectCreatedItem } from './ObjectCreatedItem';
import { PropertyUpdatedItem } from './PropertyUpdatedItem';
import { SingleEventItem } from './SingleEventItem';
import type { ItemComponentProps } from './types';

/**
 * Registry mapping item type to React component
 */
const ITEM_COMPONENTS: Record<string, ComponentType<ItemComponentProps>> = {
  [ITEM_TYPES.SINGLE_EVENT]: SingleEventItem,
  [ITEM_TYPES.ASSOCIATION_CHANGED]: AssociationChangedItem,
  [ITEM_TYPES.ASSOCIATION_ADDED]: AssociationAddedItem,
  [ITEM_TYPES.ASSOCIATION_REMOVED]: AssociationRemovedItem,
  [ITEM_TYPES.PROPERTY_UPDATED]: PropertyUpdatedItem,
  [ITEM_TYPES.OBJECT_CREATED]: ObjectCreatedItem,
};

/**
 * Get the appropriate item component for a given item type.
 *
 * Falls back to SingleEventItem for unknown types.
 */
export function getItemComponent(
  itemType: string
): ComponentType<ItemComponentProps> {
  return ITEM_COMPONENTS[itemType] || SingleEventItem;
}
